<app-barra-superior [usuLogueado]="usuLogueado" [usuRoles]="usuRoles" [rutImagen]="rutImagen" [nombre]="nomUsuario"></app-barra-superior>
<app-barra-lateral [menu]="menu" [cargando]="carMenu"></app-barra-lateral>
